const nombre = (valeur) => Number(valeur) || 0;
const centimes = (valeur) => Math.round((valeur + Number.EPSILON) * 100);

export function calculerTotauxDevis(entete, lignes, frais, codesTva = []) {
  const tauxEntete = nombre(entete.taux_tva);
  const brut = lignes.reduce((s, l) => s + nombre(l.quantite) * nombre(l.prix_vente_ttc), 0);
  const remisesLignes = lignes.reduce((s, l) => s + nombre(l.quantite) * nombre(l.prix_vente_ttc) * nombre(l.remise_pourcent) / 100, 0);
  const sousTotal = brut - remisesLignes;
  const remiseGlobale = entete.remise_globale_type === 'POURCENT'
    ? sousTotal * nombre(entete.remise_globale_valeur) / 100
    : Math.min(sousTotal, nombre(entete.remise_globale_valeur));
  const fraisVente = frais.reduce((s, f) => s + nombre(f.montant_vente_ttc), 0);
  const coutAchat = lignes.reduce((s, l) => s + nombre(l.quantite) * nombre(l.prix_achat_unitaire), 0)
    + frais.reduce((s, f) => s + nombre(f.cout_achat), 0);

  // Aucun recalcul nouveau pour les devis historiques non activés.
  if (!entete.tva_par_ligne) {
    const ttc = Math.max(0, sousTotal - remiseGlobale + fraisVente);
    const ht = ttc / (1 + tauxEntete / 100);
    const tva = ttc - ht;
    const marge = ht - coutAchat;
    return { brut, remisesLignes, sousTotal, remiseGlobale, fraisVente,
      ht, tva, ttc, coutAchat, marge, margePourcent: ht ? marge / ht * 100 : 0,
      lignesVentilees: [], tvaParTaux: [] };
  }

  const codes = new Map(codesTva.map((code) => [code.id, code]));
  const montantsLignes = lignes.map((ligne) => centimes(
    nombre(ligne.quantite) * nombre(ligne.prix_vente_ttc)
      * (1 - nombre(ligne.remise_pourcent) / 100)));
  const brutCentimes = montantsLignes.reduce((s, montant) => s + montant, 0);
  const remiseCentimes = Math.min(brutCentimes, Math.max(0,
    entete.remise_globale_type === 'POURCENT'
      ? Math.round(brutCentimes * nombre(entete.remise_globale_valeur) / 100)
      : centimes(nombre(entete.remise_globale_valeur))));
  const netCentimes = brutCentimes - remiseCentimes;
  let cumulBrut = 0;
  let cumulNet = 0;
  const repartition = new Map();
  const lignesVentilees = lignes.map((ligne, index) => {
    cumulBrut += montantsLignes[index];
    const nouveauCumulNet = brutCentimes ? Math.round(netCentimes * cumulBrut / brutCentimes) : 0;
    const ttcLigne = nouveauCumulNet - cumulNet;
    cumulNet = nouveauCumulNet;
    const taux = ligne.taux_tva_snapshot != null && ligne.taux_tva_snapshot !== ''
      ? nombre(ligne.taux_tva_snapshot)
      : nombre(codes.get(ligne.code_tva_id)?.taux_pourcent ?? tauxEntete);
    const htLigne = Math.round(ttcLigne / (1 + taux / 100));
    const cle = `${taux}`;
    const valeur = repartition.get(cle) || { taux, ht: 0, tva: 0, ttc: 0 };
    valeur.ht += htLigne;
    valeur.tva += ttcLigne - htLigne;
    valeur.ttc += ttcLigne;
    repartition.set(cle, valeur);
    return { ht: htLigne / 100, tva: (ttcLigne - htLigne) / 100,
      ttc: ttcLigne / 100, taux, marge: htLigne / 100 - nombre(ligne.quantite) * nombre(ligne.prix_achat_unitaire) };
  });
  let totalHtCentimes = lignesVentilees.reduce((s, l) => s + centimes(l.ht), 0);
  let totalTtcCentimes = netCentimes;
  frais.forEach((f) => {
    const ttcFrais = centimes(nombre(f.montant_vente_ttc));
    const htFrais = Math.round(ttcFrais / (1 + tauxEntete / 100));
    totalHtCentimes += htFrais;
    totalTtcCentimes += ttcFrais;
    const cle = `${tauxEntete}`;
    const valeur = repartition.get(cle) || { taux: tauxEntete, ht: 0, tva: 0, ttc: 0 };
    valeur.ht += htFrais; valeur.tva += ttcFrais - htFrais; valeur.ttc += ttcFrais;
    repartition.set(cle, valeur);
  });
  const ht = totalHtCentimes / 100;
  const ttc = totalTtcCentimes / 100;
  const tva = (totalTtcCentimes - totalHtCentimes) / 100;
  const marge = ht - coutAchat;
  return { brut, remisesLignes, sousTotal: brutCentimes / 100,
    remiseGlobale: remiseCentimes / 100, fraisVente, ht, tva, ttc,
    coutAchat, marge, margePourcent: ht ? marge / ht * 100 : 0,
    lignesVentilees, tvaParTaux: [...repartition.values()].sort((a, b) => b.taux - a.taux)
      .map((part) => ({ ...part, ht: part.ht / 100, tva: part.tva / 100, ttc: part.ttc / 100 })) };
}
